import LimitedTimeOfferBanner from "@components/LimitedTimeOfferBanner"
import { ReactNode } from "react"
import { StripePrice } from "src/types"

export default function LayoutPlansPage({
  children,
  currency,
  fullPrice,
  isSubmitting,
  isWeekly,
  priceId,
  setIsSubmitting,
  timeLeft,
}: {
  children: ReactNode
  currency: string
  fullPrice: StripePrice | undefined
  isSubmitting: boolean
  isWeekly: boolean
  priceId: string | undefined
  setIsSubmitting: (isSubmitting: boolean) => void
  timeLeft: string
}) {
  return (
    <div className="min-h-dvh animate-change-bg from-[#F5E1EF] to-[#DFF8FC]">
      <div className="flex min-h-dvh flex-col bg-gradient-to-b from-white to-transparent">
        {timeLeft !== "00:00" && (
          <LimitedTimeOfferBanner
            currency={currency}
            fullPrice={fullPrice}
            isSubmitting={isSubmitting}
            priceId={priceId}
            setIsSubmitting={setIsSubmitting}
            timeLeft={timeLeft}
            isWeekly={isWeekly}
          />
        )}

        <main className="custom-container flex grow flex-col justify-between gap-16 pb-14 pt-8">
          {children}
        </main>
      </div>
    </div>
  )
}
